module.exports = __webpack_public_path__ + "assets/img/img-placeholder-reel-w720.ec83a59c.jpg";